"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = App;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _root = _interopRequireDefault(require("./root"));
var _treasurerSetup = _interopRequireDefault(require("./treasurer-setup"));
var _constantParams = require("../constant-params");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
if ("production" !== 'production') {
  const ce = _react.default.createElement;
  _react.default.createElement = (component, ...args) => {
    if (!component) {
      throw new Error('Invalid component with args: ' + require('util').inspect(args));
    }
    return ce(component, ...args);
  };
}
var _ref = /*#__PURE__*/_react.default.createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
  exact: true,
  from: "/",
  to: '/year/' + _constantParams.thisYear
}), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
  exact: true,
  from: "/my-account",
  to: '/year/' + _constantParams.thisYear + '/my-account'
}), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
  exact: true,
  from: "/statistics",
  to: '/year/' + _constantParams.thisYear + '/statistics'
}), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
  exact: true,
  from: "/calendar-applications",
  to: '/year/' + (_constantParams.thisYear + 1) + '/calendar-applications'
}), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
  exact: false,
  from: "/managed-calendar",
  to: '/year/' + (_constantParams.thisYear + 1) + '/calendar-applications'
}), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
  exact: true,
  path: "/treasurer-setup/:clubID",
  component: _treasurerSetup.default
}), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
  component: _root.default
}));
function App() {
  return _ref;
}